import seo from '../router/seo'
import { productName } from '../../package.json'
import { sendEvent } from './google-analytics'
import { Loading } from 'quasar'

export default ({ router, store }) => {
  router.beforeEach((to, from, next) => {
    Loading.show()
    if (to.meta.auth == false) {
      next()
    } else {
      if (store.getters['auth/isAuthenticated']) {
        next()
      } else {
        next({
          name: 'login-form',
          query: {
            redirect: to.fullPath
          }
        })
      }
    }
  })
  router.afterEach(to => {
    if (seo[to.name]) {
      if (seo[to.name].title)
        window.document.title = seo[to.name].title + ' - ' + productName
    } else window.document.title = to.name + ' - ' + productName
    sendEvent('page_view', {
      page_title: window.document.title,
      page_location: window.document.location
    })
    /* setTimeout(() => {
      window.scrollTo(0, 0)
    }, 500) */
    Loading.hide()
  })
}
